import React from 'react'
import { SvgIcon } from '../svg-icon'

import styles from './beta-tag-illustration.module.css'

/**
 * Stateless function representing a beta tag icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <BetaTagIcon width={12} />
 */

const defaultProps = {
    keepPathColor: true
}

const BetaTagIllustration = props => (
    <SvgIcon viewBox="0 0 30 16" {...props}>
        <path
            className={styles['container']}
            d="M28,12c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V4c0-1.1,0.9-2,2-2h22c1.1,0,2,0.9,2,2V12z"
        />
        <path
            d={`M5.67,5.49h2.35c0.58,0,1.03,0.16,1.32,0.45C9.57,6.17,9.69,6.45,9.69,6.8v0.01c0,0.57-0.3,0.89-0.67,1.09
            c0.59,0.22,0.95,0.56,0.95,1.24v0.01c0,0.93-0.75,1.39-1.9,1.39H5.67V5.49z M8.58,
            6.98c0-0.33-0.26-0.52-0.73-0.52h-1.1v1.07h1.03  c0.49,0,0.8-0.16,0.8-0.54V6.98z M8.04,
            8.46H6.75v1.11h1.32c0.49,0,0.79-0.17,0.79-0.55V9.01C8.86,8.67,8.61,8.46,8.04,8.46z
            M10.89,5.49h3.82v0.99H12V7.5h2.39V8.5H12v1.06h2.75v0.99h-3.85V5.49z M16.92,
            6.51h-1.54V5.49h4.19v1.03h-1.54v4.04h-1.11V6.51z
            M21.51,5.45h1.03l2.17,5.1h-1.16l-0.46-1.14h-2.14l-0.46,1.14h-1.14L21.51,5.45z
            M22.68,8.43l-0.67-1.64l-0.67,1.64H22.68z`}
        />
    </SvgIcon>
)

BetaTagIllustration.defaultProps = defaultProps

export { BetaTagIllustration }
